export default "__VITE_ASSET__BMAw9Qtp__"